export function showSuspiciousApplicationNotice(vm) {
    return vm.$confirm(
        '<p><strong>Your registration has been submitted.</strong> This message only means it triggered an additional manual review. It does not mean the registration failed.</p>' +
        '<p style="margin-top: 10px;"><strong style="color: #f56c6c;">Do not submit again with the same email. Do not use a different email to submit another registration.</strong></p>' +
        '<p style="margin-top: 10px;">Duplicate registrations can delay the review process and may be cancelled.</p>',
        'Registration Submitted - Manual Review Triggered',
        {
            confirmButtonText: 'I Understand - Do Not Resubmit',
            type: 'warning',
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
            closeOnClickModal: false,
            closeOnPressEscape: false
        }
    )
}
